import { createContext } from "react";
const ZIndexStackContext = createContext(1),
  ZIndexHardcodedContext = createContext(void 0);
export { ZIndexHardcodedContext, ZIndexStackContext };
//# sourceMappingURL=context.mjs.map
